import InternalAssignments from './InternalAssignments';

export default InternalAssignments;
